// extracted by mini-css-extract-plugin
export default {"appIconBtn":"AppIconBtn_appIconBtn__dEnml","smallBtn":"AppIconBtn_smallBtn__PoBCc"};